import { render } from "./courseMajorDetail.vue?vue&type=template&id=6bb726ca&scoped=true"
import script from "./courseMajorDetail.vue?vue&type=script&lang=js"
export * from "./courseMajorDetail.vue?vue&type=script&lang=js"

import "./courseMajorDetail.vue?vue&type=style&index=0&id=6bb726ca&scoped=true&lang=css"
import "./courseMajorDetail.vue?vue&type=style&index=1&id=6bb726ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb726ca"]])

export default __exports__